import { TMenuSection } from 'features/generator/contentFormSections/MenuForm/MenuForm'

import { ProductItem } from './ProductItem'

export const SectionItem = ({
	section,
	demoMode,
}: {
	section: TMenuSection
	demoMode: boolean
}) => {
	const filteredProducts = section.products.filter((product) => product.visible)

	return (
		<div className="flex flex-col gap-4 rounded-6 bg-white p-4 shadow-generator word-break-fix">
			<div className="flex w-full flex-col gap-1">
				{section.name && (
					<h4 className="type-body-medium break-keep font-semibold">
						{section.name}
					</h4>
				)}
				{section.nameTranslation && (
					<p className="type-body-caption break-keep text-dark-grey">
						{section.nameTranslation}
					</p>
				)}
			</div>
			{section.description ||
				(section.descriptionTranslation && (
					<div className="flex flex-col gap-1">
						{section.description && (
							<h4 className="type-body-small break-keep">
								{section.description}
							</h4>
						)}
						{section.descriptionTranslation && (
							<p className="type-body-caption break-keep text-dark-grey">
								{section.descriptionTranslation}
							</p>
						)}
					</div>
				))}
			<div className="border-t border-t-border-grey-50" />
			{filteredProducts.map((product, index) => (
				<>
					<ProductItem key={index} product={product} demoMode={demoMode} />
					{index !== filteredProducts.length - 1 && (
						<div className="border-t border-t-border-grey-50" />
					)}
				</>
			))}
		</div>
	)
}
